import * as React from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';

import theme from 'styles/theme';
import icons from './icons';
import { color, variants } from 'styles/utils';

const StyledIcon = styled.span`
  color: ${(p) => (p.$color ? color(p.$color, p.$color) : 'inherit')};
  overflow: visible;
  pointer-events: none;

  *:where(:not([fill='none'])) {
    fill: currentcolor;
  }

  *:where([stroke]:not([stroke='none'])) {
    stroke: currentcolor;
    vector-effect: non-scaling-stroke;
  }

  &[fill='none'] *:where(:not([fill])),
  [fill='none'] *:where(:not([fill])) {
    fill: none;
  }

  &[stroke='none'] *:where(:not([stroke])),
  [stroke='none'] *:where(:not([stroke])) {
    stroke: none;
  }

  ${variants({
    inline: css`
      display: inline-block;
      height: 1em;
      width: auto;
      vertical-align: text-bottom;

      ${({ $size }) => {
        const sizes = {
          sm: 'font-size: 75%',
          md: 'font-size: 100%',
          lg: 'font-size: 150%',
          xl: 'font-size: 200%',
        };
        if ($size) {
          return $size in sizes ? sizes[$size] : `font-size: ${$size}`;
        }
      }}
    `,
    block: `
      height: 100%;
      width: 100%;
    `,
  })}
`;

function Icon({ color, name, size, ...props }) {
  if (name in icons) {
    const Component = icons[name];
    return (
      <StyledIcon
        aria-hidden="true"
        as={Component}
        data-icon={name}
        $color={color}
        $size={size}
        {...props}
      />
    );
  }
  return null;
}

Icon.propTypes = {
  color: PropTypes.oneOf(Object.keys(theme.colors)),
  name: PropTypes.oneOf(Object.keys(icons)).isRequired,
  size: PropTypes.string,
  variant: PropTypes.oneOf(['block', 'inline']),
};

Icon.defaultProps = {
  color: undefined,
  name: undefined,
  size: undefined,
  variant: 'inline',
};

export default Icon;
